import React, { useEffect } from "react";
import {
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import { useToasts } from "react-toast-notifications";
import { useDispatch, useSelector } from "react-redux";
import { useAccount } from "wagmi";
import { fetchUserInfo, removeToast } from "./redux/slices/UserSlice";
import CreateCollectionOptions from "./pages/CreateCollectionOptions";
import CreateCollection from "./pages/CreateCollection";
import CreateNFT from "./pages/CreateNFT";
import CollectionInfo from "./pages/CollectionInfo";
import NFTInfo from "./pages/NFTInfo";
import ScrollToTop from "./components/ScrollToTop";
import Collections from "./pages/Collections";
import ExploreNft from "./pages/ExploreNft";
import MyProfile from "./pages/MyProfile";


function App() {

  const { addToast } = useToasts();
  const errormessage = useSelector(state => state.user.error);
  const successmessage = useSelector(state => state.user.success);
  const { address } = useAccount();
  const dispatch = useDispatch();
  const location = useLocation();


  useEffect(() => {

    dispatch(fetchUserInfo({
      address
    }))

    const script = document.createElement('script');
    script.src = process.env.PUBLIC_URL + '/js/designesia.js';
    document.body.appendChild(script);

  }, [address, location.pathname, dispatch]);


  useEffect(() => {
    if (errormessage) {
      addToast(errormessage, { appearance: 'error', });
    }

    if (successmessage) {
      addToast(successmessage, { appearance: 'success', });
    }
    dispatch(removeToast())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errormessage, successmessage])



  return (
    <div className="App">

      <ScrollToTop />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/profile" element={<Profile />} />
        <Route exact path="/create-collection/options" element={<CreateCollectionOptions />} />
        <Route exact path="/create-collection/:id" element={<CreateCollection />} />
        <Route exact path="/create-nft" element={<CreateNFT />} />
        <Route exact path="/collection/:nftaddress" element={<CollectionInfo />} />
        <Route exact path="/:nftaddress/:tokenId" element={<NFTInfo />} />
        <Route exact path="/collections" element={<Collections />} />
        <Route exact path="/explore-nfts" element={<ExploreNft />} />
        <Route exact path="/my-profile" element={<MyProfile />} />
      </Routes>

    </div>
  );
}

export default App;
